module.exports = __webpack_public_path__ + "static/media/glittek-granites.58d6f625.png";